<template>
    <BaseCheckbox
        :model-value="checkedCategories.includes(node.data.id)"
        @update:model-value="$emit('check', {value: $event, id: node.data.id})">
        {{ node.label }}
    </BaseCheckbox>
</template>

<script>

export default {
    name: "CategoryCheckbox",
    props: {
        node: {type: Object, required: true},
        checkedCategories: {type: Array, default: () => []},
    }
}
</script>

<style scoped>

</style>
